import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import api from '../../seller-apis/api'
import VideoTutCard from '../common/VideoTutCard'
import '../../assets/css/VidTutorials.css'
import { Button,Modal } from 'react-bootstrap'
var allscrollLen = 0;
var globalFilter = {
    "pageNo": 1
};
const VideosTuts = () => {

    const [data, setData] = useState([])
    const [allRecords, setallRecords] = useState();
    const [currLink, setCurrLink] = useState("")
    // Loader 
    const [ennewloader, setennewloader] = useState("block");

    // Scroll related events
    const [isallcrollBtnVis, setisallcrollBtnVis] = useState("none");
    const [loadText, setloadText] = useState("Load More")

    // Modal
    const [modalShow, setModalShow] = useState(false)


    useEffect(() => {
        globalFilter = {
            "pageNo": 1
        }
        allscrollLen = 1;
        api.tutorials.getTutorialVids().then(res => {
            setData(res.data)
            setallRecords(res.totalRecords)
            setennewloader("none")
        }).catch(err => console.log(err))
    }, [])

    const modalHandleClose = () => {
        setModalShow(false)
    }



    // load more 

    function loadMore() {
        if (loadText !== "Loading...") {
            setloadText("Loading...")
            allscrollLen = allscrollLen + 1;
            globalFilter.pageNo = allscrollLen
            api.tutorials.getTutorialVids().then(res => {
                setloadText("Load more")
                setData(data => data.concat(res.data))
            }).catch(err => console.log(err))
        }
    }

    // play video

    function playVideo(link) {
        setCurrLink(link)
        setModalShow(true)
    }

    return (
        <div className='vid_tuts_main'>
            <h3 className='text-center'><i className="bi bi-camera-video"></i> Tutorials</h3>
            <div className='vid_tuts_cntn'>
                {data && data.length > 0 ? data.map((item, index) => {
                    let lastIndex = item.url.lastIndexOf("/");
                    let vidStr = item.url.substr(lastIndex + 1)
                    if (item.status && item.status === "Active") {
                        return (
                            <VideoTutCard
                                key={index}
                                link={vidStr}
                                title={item.title}
                                playVid={playVideo}
                            />
                        )
                    }
                }) : <></>}
            </div>
            <div className="d-flex justify-content-center" id="enNewLoader" >
                <div className="spinner-border" role="status" style={{ "display": ennewloader }}>
                    <span className="sr-only"></span>
                </div>
            </div>

            {allscrollLen * 50 <= allRecords ? <div className='loadMorecntn d-flex justify-content-center '>
                <button className='payment_btn_export mt-4' onClick={() => loadMore()}>{loadText}</button>
            </div> : isallcrollBtnVis === "block" ? <><p className="pageendTxt text-center mt-4">Looks like you have reached bottom of the page</p></> : <></>}


            <div className='scrolltoptnCnt' style={{ "display": isallcrollBtnVis }}>
                <a href='#orDeskContain'>
                    <Button variant="dark"><i class="fa fa-arrow-up" aria-hidden="true"></i></Button>
                </a>

            </div>

            {/* Image showing modal */}


            <Modal
                show={modalShow}
                onHide={modalHandleClose}
                backdrop="static"
                keyboard={false}
                className="modal_vid_tut_iframe"
                centered
                size='lg'
            >
                <button className='my_Modal_close_btn_iframe' onClick={()=>modalHandleClose()}>X</button>
                <Modal.Body className="modal_body_1">
                    <iframe
                        allowFullScreen
                        className="d-block iframe_vid_tuts w-100"
                        src={"https://www.youtube.com/embed/" + currLink+"?autoplay=1"}>
                    </iframe>


                </Modal.Body>

            </Modal>
        </div>
    )
}

export default VideosTuts